"use client";

import * as React from "react";
import { MessageCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouchWithSamBrandingMarketing() {
  const {
    ref: iconRef,
    isVisible: iconVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-accent-light via-primary-light to-secondary-light overflow-hidden py-20 px-4 sm:px-6 lg:px-8">
      {}
      <div ref={iconRef} className="absolute inset-0 flex items-center justify-center pointer-events-none transition-opacity duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
      opacity: iconVisible ? 1 : 0
    }}>
        <MessageCircle className="text-primary/10 transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
        width: "min(70vw, 600px)",
        height: "min(70vw, 600px)",
        transform: iconVisible ? "rotate(0deg)" : "rotate(-15deg)"
      }} strokeWidth={0.5} />
      </div>

      {}
      <div className="relative z-10 flex items-end justify-center min-h-[70vh] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/contact_communication_backdrop.png)]">
        <Card className="w-full max-w-2xl bg-background/95 backdrop-blur-md border border-border/30 shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] rounded-xl transition-all duration-300 ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(0,0,0,0.16),0_0_24px_hsl(45,95%,55%)] group">
          <CardContent className="p-6 sm:p-12">
            <div className="space-y-6">
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
                Get in Touch with Sam Branding & Marketing
              </h2>
              <p className="text-lg sm:text-xl text-foreground/80 leading-relaxed">
                Ready to transform your brand and grow your business? We're here to help you succeed with our comprehensive marketing and branding solutions. Let's start a conversation about your goals.
              </p>
              <div className="pt-4 space-y-3">
                <p className="flex items-center gap-3 text-foreground/70">
                  <span className="font-semibold text-primary">Email:</span>
                  <Link to="mailto:contact@sambrandingandmarketing.com" className="hover:text-accent transition-colors duration-[var(--duration-fast)]">
                    contact@sambrandingandmarketing.com
                  </Link>
                </p>
                <p className="flex items-center gap-3 text-foreground/70">
                  <span className="font-semibold text-primary">Phone:</span>
                  <Link to="tel:+971501813277" className="hover:text-accent transition-colors duration-[var(--duration-fast)]">
                    +971 50 181 3277
                  </Link>
                </p>
                <p className="flex items-center gap-3 text-foreground/70">
                  <span className="font-semibold text-primary">Hours:</span>
                  <span>Mon-Fri: 9am - 6pm; Sat: 10am - 4pm</span>
                </p>
              </div>
            </div>

            {}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-0.5 bg-accent/30 rounded-full animate-pulse" />
          </CardContent>
        </Card>
      </div>
    </section>;
}